export default __webpack_public_path__ + "static/media/sm.94ceecd9.jpg";